module.exports = __webpack_public_path__ + "media/images/buriel-2-7cbb5ca04935a28d7295a4a307f5047c.png";